/*
  Mara Spirit : ouverture des sous-menus du menu principal au survol (ordinateur).
  Réglage : Paramètres du thème → Mara — Modernisation → Menu principal.
  S'appuie sur le fonctionnement natif de Dawn (<header-menu><details>) :
  on se contente d'ouvrir et fermer les <details>, le clavier et le toucher
  continuent de fonctionner comme avant.
*/
(function () {
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  const CLOSE_DELAY = 180;

  function init() {
    const menus = document.querySelectorAll('.header__inline-menu header-menu > details');
    if (!menus.length) return;

    menus.forEach((details) => {
      const summary = details.querySelector('summary');
      let closeTimer = null;
      let openedByHover = false;

      const open = () => {
        clearTimeout(closeTimer);
        if (!canHover.matches || details.open) return;
        menus.forEach((other) => {
          if (other !== details && other.open) other.open = false;
        });
        details.open = true;
        openedByHover = true;
        summary.setAttribute('aria-expanded', 'true');
      };

      const close = () => {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          if (!canHover.matches || !openedByHover) return;
          if (details.contains(document.activeElement) && document.activeElement !== summary) return;
          details.open = false;
          openedByHover = false;
          summary.setAttribute('aria-expanded', 'false');
        }, CLOSE_DELAY);
      };

      details.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') open();
      });
      details.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') close();
      });

      // Un clic juste après l'ouverture au survol ne doit pas refermer le menu.
      summary.addEventListener('click', (event) => {
        if (canHover.matches && openedByHover && details.open) {
          event.preventDefault();
        }
      });

      details.addEventListener('toggle', () => {
        if (!details.open) openedByHover = false;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
